class SponsorAnalytics {
    constructor({ sponsorName = "", sponsorUid = "", clickData = [] }) {
        this.sponsorName = sponsorName;
        this.sponsorUid = sponsorUid;
        this.clickData = clickData
    }

    toObject() {
        return {
            sponsorName: this.sponsorName || "",
            sponsorUid: this.sponsorUid || "",
            clickData: this.clickData || []
        }
    }

    static fromObject(sponsorAnalytics) {
        return new SponsorAnalytics({
            sponsorName: sponsorAnalytics.sponsorName || "",
            sponsorUid: sponsorAnalytics.sponsorUid || "",
            clickData: sponsorAnalytics.clickData || []
        })
    }
}
export default SponsorAnalytics;